import {ISVG} from "../../common/Logo/Logo";

export interface ICircle2Props extends Pick<ISVG, "fill"> {}

export const Circle4 = ({ fill }: ICircle2Props) => {
    const _fill = fill ?? "#B3EBE4";

    return (
        <svg
            width="130"
            height="129"
            viewBox="0 0 130 129"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M62.244 0.104609C80.6626 -0.610594 100.103 2.12911 113.311 14.9517C126.65 27.902 130.164 47.3149 129.994 65.8796C129.826 84.2444 125.895 103.403 112.387 115.886C99.2436 128.033 80.1264 129.633 62.244 128.489C45.6818 127.43 29.8226 121.619 18.1433 109.86C6.51995 98.1574 0.626111 82.3418 0.0588862 65.8796C-0.530742 48.7673 3.22642 31.2271 15.0047 18.7689C27.0834 5.99286 44.65 0.787793 62.244 0.104609Z"
                fill={_fill}
            />
        </svg>
    );
};
